import { render, staticRenderFns } from "./AnswerTypeTextarea.vue?vue&type=template&id=dee489e8"
import script from "./AnswerTypeTextarea.vue?vue&type=script&lang=js"
export * from "./AnswerTypeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports